module.exports = __webpack_public_path__ + "media/39.de4a2268.mp3";